import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { fetchTopChartsMaxDate } from '@/pages/intelligence/services/topcharts';
export const TIMEHASDATA_NAMESPACE = 'intelligence_filter_timehasdata';
const MARKET_FILTER_TYPES = Object.keys(hasDataTimerParams).map((t) => {
  return hasDataTimerParams[t]?.type;
});

export const getTypeMsg = (type = '') => {
  if (type && typeof type === 'string') {
    const initState = `${type[0].toUpperCase()}${type.slice(1)}TimeHasData`;
    return {
      state: initState,
      get: `get${initState}`,
      save: `save${initState}`,
    };
  }
  return {
    state: '',
    get: '',
    save: '',
  };
};

const initialState = MARKET_FILTER_TYPES.reduce(
  (state, type) => ({
    ...state,
    [getTypeMsg(type).state]: {
      loading: false,
      data: null,
    },
  }),
  {},
);

const getTimeHasDataFilter = (type) =>
  function* ({ payload }, { put }) {
    const saveTypeName = getTypeMsg(type).save;
    try {
      yield put({
        type: saveTypeName,
        payload: { loading: true, data: null },
      });

      let result = null;
      result = yield fetchTopChartsMaxDate(payload);
      yield put({
        type: saveTypeName,
        // payload: { loading: false, data: getDefulatTimeValue(result) },
        payload: { loading: false, data: result },
      });
      return result;
    } catch (e: any) {
      yield put({
        type: saveTypeName,
        payload: { loading: false, data: null, errMsg: e?.message },
      });
    }
  };

const saveMarketFilter = (type) =>
  function (state, action) {
    return { ...state, [getTypeMsg(type).state]: action.payload };
  };

const MonetizationModel = {
  namespace: TIMEHASDATA_NAMESPACE,
  state: initialState,

  effects: MARKET_FILTER_TYPES.reduce(
    (effects, type) => ({
      ...effects,
      [getTypeMsg(type).get]: getTimeHasDataFilter(type),
    }),
    {},
  ),

  reducers: MARKET_FILTER_TYPES.reduce(
    (reducers, type) => ({
      ...reducers,
      [getTypeMsg(type).save]: saveMarketFilter(type),
    }),
    {},
  ),
};

export default MonetizationModel;
